import { render, staticRenderFns } from "./cc-selector.vue?vue&type=template&id=cf89853e&scoped=true"
import script from "./cc-selector.vue?vue&type=script&lang=ts"
export * from "./cc-selector.vue?vue&type=script&lang=ts"
import style0 from "./cc-selector.vue?vue&type=style&index=0&id=cf89853e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf89853e",
  null
  
)

export default component.exports